export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const SAVE_VIEW_EMPLOYEE = "SAVE_VIEW_EMPLOYEE";
export const EMPLOYEE_DETAILS = "EMPLOYEE_DETAILS";
export const LOGOUT = "LOGOUT";